import React from "react";

import Login from "./views/Login";
import { Redirect } from "react-router";

class LoginContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      /* Form */
      fields: {}, // Handle onChange of FormElements
      errors: {}, // Form Errors

      isLoggedIn: window.sessionStorage.getItem("isLoggedIn"),
    };
  }

  /* Form Functions */

  // Validate Email using Regex
  _validEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
  };

  // Handle Input Changes
  handleChange = (e) => {
    let name = e.target.getAttribute("name");
    let value = e.target.value;

    let fields = this.state.fields;

    fields[name] = value;

    this.setState({ fields });
  };

  // Validate Form + Create Error Messages if Needed
  _validForm = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Email is verplicht";
    } else if (!this._validEmail(fields["email"])) {
      formIsValid = false;
      errors["email"] = "Geen geldig emailadres";
    }

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Wachtwoord is verplicht";
    }

    this.setState({ errors: errors });

    return formIsValid;
  };

  /* Submit Forms */

  // Handle Submit Login
  handleSubmit = (e) => {
    e.preventDefault();

    if (this._validForm()) {
      // Do fetch(), or axios(), or any http request to server

      //Do these 2 lines if call to server was success
      window.sessionStorage.setItem("isLoggedIn", true);
      this.setState({ isLoggedIn: true });

      // If error occured (and it has a message in the response)
      let errors = this.state.errors;
      errors["submitError"] = "error message van database hier";
      this.setState({
        errors: errors,
      });
    }
  };

  render() {
    if (this.state.isLoggedIn) {
      return <Redirect to='/dashboard' />;
    }

    return <Login formErrors={this.state.errors} handleSubmit={this.handleSubmit} handleChange={this.handleChange} />;
  }
}

export default LoginContainer;
